import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { CommonService } from '../../core/services/common.service';
import { BookADemoModal } from '../../core/modals/bookADemo.modal';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-pick-a-slot',
  templateUrl: './pick-a-slot.component.html',
  styleUrls: ['./pick-a-slot.component.scss']
})
export class PickASlotComponent implements OnInit {

  constructor(private meta: Meta, public commonService: CommonService) {
    this.meta.addTags([
      { name: 'description', content: 'Pick a time slot to book a demo' },
      { name: 'author', content: 'Amy.pro' },
      { name: 'keywords', content: 'Angular, Aumnics' }
    ]);
    this.commonService.setTitle('Pick a slot');
  }

  @Input() public headingTitle = 'Appointment Date & Time';
  @Input() public minDate: Date = new Date();
  @Input() public maxDate!: Date;
  @Input() public disabledDays: number[] = [0, 6];

  @Input() public selectedDate: Date = new Date();
  @Input() public selectedTimeZone: any;
  @Input() public selectedSlot: any = null;
  @Input() public bookADemoObj: BookADemoModal = new BookADemoModal();

  @Input() public showButtons: boolean = true;
  @Input() public showCancelButton: boolean = true;
  @Input() public cancelButtonText: string = 'Back';
  @Input() public saveButtonText: string = 'Book the slot';
  @Input() public loader: boolean = false;

  @Output() public pickASlotEmitter = new EventEmitter<any>();

  public timeSlots: any[] = [];
  public filteredTimeSlots: any[] = [];
  public timezoneOpts: any[] = [];
  public slotsLoader: boolean = true;

  homePathUrl:any;

  ngOnInit(): void {
    this.homePathUrl = environment.imgpathUrl;
    this.getAllTimezones();
  }

  public getAllTimezones() {
    this.commonService.getAllTimeZones().subscribe((res: any) => {
      this.timezoneOpts = res.message.allTimeZones;
      this.getSlots();
    });
  }

  public getSlots() {
    if (!this.selectedDate) {
      this.selectedDate = new Date();
    }
    const obj = {
      roleId: this.bookADemoObj.demoType == 1 ? 46 : 47,
      emailId: this.bookADemoObj.email,
      skillGroupIds: this.bookADemoObj.skillGroupIds,
      cityId: this.bookADemoObj.locationInfo.cityId,
      duration: this.bookADemoObj.duration,
      date: this.formattedDateForBackend(this.selectedDate),
    }
    this.timeSlots = [];
    this.slotsLoader = true;
    this.commonService.getDemoSlots(obj).subscribe((res: any) => {
      this.bookADemoObj.executiveWorkId = res.message.executiveWorkId;
      this.bookADemoObj.roleId = res.message.executiveRoleId;
      this.timeSlots = res.message.availabilityTimes;
      this.convertDate();
      this.slotsLoader = false;
    }, err => {
      // this.commonService.showToaster(err.message.errorMessage, 'error', 'Error');
      this.timeSlots = [];
      this.slotsLoader = false;
    });
  }

  public convertDate() {
    this.filteredTimeSlots = [];
    for (const slot of this.timeSlots) {
      const currentTime = new Date();
      //console.log(currentTime);
      const startTime = this.commonService.convertDateByTimeZone(slot.startTime, this.selectedTimeZone.location);
      const endTime = this.commonService.convertDateByTimeZone(slot.endTime, this.selectedTimeZone.location);
      const startTimeToCompare = new Date(startTime);
      if (this.selectedDate.getDate() == startTime.getDate() && startTimeToCompare > currentTime) {
        this.filteredTimeSlots.push({ startTime, endTime });
      }
    }
  }

  public onSelectDate(event: any) {
    this.getSlots();
    this.selectedSlot = null;
  }

  public onSelectedSlot(slot: any) {
    this.selectedSlot = slot;
    if (!this.showButtons && this.selectedDate && this.selectedTimeZone != null && this.selectedSlot != null) {
      this.emitData(true);
    }
  }

  public emitData(status: Boolean) {
    if (status) {
      this.bookADemoObj.timezoneInfo = this.selectedTimeZone;
      this.bookADemoObj.timezoneId = this.selectedTimeZone.id;
      this.bookADemoObj.demoTime = this.bookADemoObj.demoStartTime = this.filteredTimeSlots[this.selectedSlot].startTime;
      this.bookADemoObj.demoEndTime = this.filteredTimeSlots[this.selectedSlot].endTime;
    }
    this.pickASlotEmitter.emit({ status, ...this.bookADemoObj })
  }

  public formattedDateForBackend(date, divided = '-') {
    if (!date) { return; }
    const m = ('0' + (date.getMonth() + 1)).slice(-2); // in javascript month start from 0.
    const d = ('0' + date.getDate()).slice(-2); // add leading zero
    const y = date.getFullYear();
    return y + divided + m + divided + d + 'T00:00:00.000Z';
  }


}
